import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import BlockIcon from '@mui/icons-material/Block';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function () {

    const [expandIncluded, setExpandIncluded] = useState(true);
    const [expandNotIncluded, setExpandNotIncluded] = useState(false);

    const notIncludedStuff = ["Golf Clubs", "Shoe Hire"]
    const includedStuff = ["Valet Parking", "Personalised locker sign", "'The Grove' valuable pouches, inc. tees and pencils", "18-hole course", "Three Course Buffet Dinner", "Use of Short Game Area and Practice Putting Green", "Competitions including 'Nearest the Pin' and 'Longest Drive'", "Locker Room Facilities", "Golf Buggies with live scoring and GPS",]

    return <Stack spacing={2} className="WhatsIncludedSection">
        <Typography className="Title" variant="bold">What's Included</Typography>
        <Accordion expanded={expandIncluded} onChange={() => setExpandIncluded(!expandIncluded)}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
            >
                <Typography>What's Included
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack className="AccordionItems">
                    {
                        includedStuff.map(text => {
                            return <Stack className="Item">
                                <CheckCircleOutlineIcon color="primary" />
                                <Typography>{text}</Typography>
                            </Stack>
                        })
                    }
                </Stack>
            </AccordionDetails>
        </Accordion>

        <Accordion expanded={expandNotIncluded} onChange={() => setExpandNotIncluded(!expandNotIncluded)}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
            >
                <Typography>What's Not Included
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack className="AccordionItems">
                    {
                        notIncludedStuff.map(text => {
                            return <Stack className="Item">
                                <BlockIcon color="danger" />
                                <Typography>{text}</Typography>
                            </Stack>
                        })
                    }
                </Stack>
            </AccordionDetails>
        </Accordion>

    </Stack>
}